import CustomCell from "./custom-cell";


const columns = [
    {
        cell:({dataIndex})=><td style={{padding:"0" ,textAlign:"center"}}>{ dataIndex + 1 }</td>,
        title:"",
        width:30
    },
    {
        title:"Name",
        field:"name",
        width:300,
        cell:CustomCell
    },
    {
        title:"Abbreviation",
        field:"Abbreviation",
        width:300,
        cell:CustomCell
    },
    {
        title:"Description",
        field:"Description",
        width:400,
        cell:CustomCell
    },
    {
        title:"Treatment",
        field:"Treatment",
        width:300,
        cell:CustomCell
    },
    {
        title:"Usage",
        field:"Usage",
        width:400,
        cell:CustomCell
    },
]

export default columns